export default __webpack_public_path__ + "static/media/Nokia.66bff3bc.png";